<template>
  <div class="row">
    <div class="col-12 col-xl-6 p-0">
      <Card class="android-app">
        <span class="header">
          {{ $t('androidApp.downloadApp') }}
        </span>
        <hr>
        <AndroidAppsForm />
      </Card>
    </div>
  </div>
</template>

<script>
import AndroidAppsForm from '@/components/AndroidApps.vue';

export default {
  name: 'AndroidApps',
  components: {
    AndroidAppsForm,
  },
};
</script>


<style lang="scss" scoped>
.android-app {
  margin-left: 15px;

  .header {
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
}
</style>
